// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4374":"3b53517f","6799":"3b53517f","7325":"3b53517f"}[chunkId] + ".chunk.css";
};